export default {
  translation: {
    key: 'value',

    'Group Input Node': 'Group Input Node',
    'Group Output Node': 'Group Output Node',
    'Group Node': 'Group Node',
    'Group Instance Node': 'Group Instance Node',
    'Alert Node': 'Alert Node',
    'Input Node': 'Input Node',
    'Output Node': 'Output Node',

    Home: 'Home',
    Tasks: 'AI Tasks',
    Customers: 'Customers',
    'Chart of Accounts': 'Chart of Accounts',
    Reports: 'Reports',
    Flows: 'Flows',
    Contexts: 'Contexts',
    Assistants: 'Assistants',
    History: 'History',
    'Organisation settings': 'Organisation settings',
    'Provide Feedback': 'Provide Feedback',
    Topic: 'Topic',
    Feedback: 'Feedback',
    Rating: 'Rating',
    Cancel: 'Cancel',
    Submit: 'Submit',
    Journal: 'Journal',
    'General Ledger': 'General Ledger',
    Dimensions: 'Dimensions',
    Date: 'Date',
    Instructions: 'Instructions',
    Amount: 'Amount',
    Account: 'Account',
    Balance: 'Balance',
    'Sort by date:': 'Sort by date:',
    'Oldest first': 'Oldest first',
    'Newest first': 'Newest first',
    'Filter by dimension': 'Filter by dimension',

    // Document page
    'View full size': 'View full size',
    'Download receipt': 'Download receipt',
    'No receipts to download': 'No receipts to download',
    'Download filtered receipts': 'Download filtered receipts',
    'Download all receipts': 'Download all receipts',
    'Reset all filters': 'Reset all filters',
    Reset: 'Reset',
    'Grid View': 'Grid View',
    'Table View': 'Table View',

    // Table headers and filters
    Image: 'Image',
    Title: 'Title',
    Category: 'Category',
    Status: 'Status',
    'All Categories': 'All Categories',
    Month: 'Month',
    Year: 'Year',

    // Status indicators
    NEW: 'NEW',
    IN_PROGRESS: 'IN PROGRESS',
    PENDING: 'PENDING',
    COMPLETED: 'COMPLETED',
    ALL_STATUSES: 'All Statuses',

    // Navigation and pages
    Activity: 'Activity',
    Files: 'Files',
    Settings: 'Settings',
    Dashboard: 'Dashboard',
    'Sign out': 'Sign out',
    'Page Not Found': 'Page Not Found',
    "The page you're looking for doesn't exist.":
      "The page you're looking for doesn't exist.",

    // Organization
    'Personal account for': 'Personal account for',
    'New organisation name': 'New organisation name',
    'Unnamed organisation': 'Unnamed organisation',

    // Language names
    English: 'English',
    Suomi: 'Finnish',
    Svenska: 'Swedish',
    Dansk: 'Danish',

    // Header
    Floness: 'Floness',

    // Tasks page
    'Customer:': 'Customer:',
    'Customer ID:': 'Customer ID:',
    'Created:': 'Created:',
    'Due:': 'Due:',
    'Type:': 'Type:',
    'Show active tasks only': 'Show active tasks only',

    // Categories
    Expenses: 'Expenses',
    Sales: 'Sales',
    'Bank Statements': 'Bank Statements',
    'Documents Category': 'Documents',
    Other: 'Other',

    // Months
    January: 'January',
    February: 'February',
    March: 'March',
    April: 'April',
    May: 'May',
    June: 'June',
    July: 'July',
    August: 'August',
    September: 'September',
    October: 'October',
    November: 'November',
    December: 'December',
    'All Months': 'All Months',
    'All Years': 'All Years',
    'Thinking...': 'Thinking...',
    'Type a message...': 'Type a message...',
    'Loading chat history...': 'Loading chat history...',
    'Chat thread not found': 'Chat thread not found',
    'Failed to initialize chat': 'Failed to initialize chat',
    'No messages found in this chat': 'No messages found in this chat',
    'Failed to load chat history': 'Failed to load chat history',
    'An unexpected error occurred': 'An unexpected error occurred',
    'Something went wrong': 'Something went wrong',
    'No chat thread available': 'No chat thread available',
    'This activity entry or file does not have an associated chat thread yet.':
      'This activity entry or file does not have an associated chat thread yet.',
    Retry: 'Retry',
    Refresh: 'Refresh',
    'Refreshing...': 'Refreshing...',
    'Scroll to bottom': 'Scroll to bottom',

    // Dashboard Items
    'Latest entry': 'Latest entry',
    'Latest file': 'Latest file',
    'Latest task': 'Latest task',
    'Latest description': 'Latest description',
    'Latest instruction': 'Latest Instruction',

    'password-requirements':
      'Password must be at least 10 characters long and contain at least one uppercase, one lowercase, and one number.',

    // Plural forms
    'n-entries': 'entries',
    'n-tasks': 'tasks',
    'n-descriptions': 'descriptions',
    'n-instructions': 'instructions',
    'n-files': 'files',

    '1-entry': 'entry',
    '1-task': 'task',
    '1-description': 'description',
    '1-instruction': 'instruction',
    '1-file': 'file',

    // DocumentChat
    'Assistant is thinking...': 'Assistant is thinking...',
    'Waiting for entrepreneur...': 'Waiting for entrepreneur...',
    'Waiting for accountant...': 'Waiting for accountant...',

    // EditableTable
    Actions: 'Actions',
    'Add Row': 'Add Row',
    'No tasks available': 'No tasks available',
    'No descriptions available': 'No descriptions available',
    'No instructions available': 'No instructions available',

    // Tasks page
    Task: 'Task',
    'Save Tasks': 'Save Tasks',
    'Failed to load tasks data': 'Failed to load tasks data',
    'Tasks saved successfully': 'Tasks saved successfully',
    'Failed to save tasks': 'Failed to save tasks',
    Enter: 'Enter',

    // Description page
    Description: 'Description',
    'Save Descriptions': 'Save Descriptions',
    'Failed to load descriptions data': 'Failed to load descriptions data',
    'Descriptions saved successfully': 'Descriptions saved successfully',
    'Failed to save descriptions': 'Failed to save descriptions',

    // Instructions page
    Instruction: 'Instruction',
    'Save Instructions': 'Save Instructions',
    'Failed to load instructions data': 'Failed to load instructions data',
    'Instructions saved successfully': 'Instructions saved successfully',
    'Failed to save instructions': 'Failed to save instructions',

    // Settings page
    'Organisation Settings': 'Organisation Settings',
    'Accountant Settings': 'Accountant Settings',
    'Accountant email': 'Accountant email',
    'Bank Statement Frequency': 'Bank Statement Frequency',
    'Do not send bank statements': 'Do not send bank statements',
    'Send bank statements daily': 'Send bank statements daily',
    'Send bank statements monthly': 'Send bank statements monthly',
    'Send all vouchers': 'Send all vouchers',
    'Accounting start date': 'Accounting start date',
    'Netvisor Integration': 'Netvisor Integration',
    'Organization ID': 'Organization ID',
    'User ID': 'User ID',
    'User key': 'User key',
    'Save Netvisor Settings': 'Save Netvisor Settings',
    'Fennoa Integration': 'Fennoa Integration',
    Username: 'Username',
    'API Key': 'API key',
    'Save Fennoa Settings': 'Save Fennoa Settings',
    'Fortnox Integration': 'Fortnox Integration',
    'Fortnox integration is enabled': 'Fortnox integration is enabled',
    'Connect your Fortnox account to enable integration':
      'Connect your Fortnox account to enable integration',
    'Connect to Fortnox': 'Connect to Fortnox',
    'Organisation members': 'Organisation members',
    Name: 'Name',
    'User identifier': 'User identifier',
    Rights: 'Rights',
    Call: 'Call',
    Add: 'Add',

    // DocumentsTable
    Today: 'Today',
    Yesterday: 'Yesterday',
    'Unknown Date': 'Unknown Date',
    'days ago': 'days ago',
    'Search entries...': 'Search entries...',
    Filters: 'Filters',

    // DocumentGridItem
    'New chat': 'New chat',
    'No description': 'No description',

    // FilesTable
    'Search files...': 'Search files...',
    receipt: 'receipt',
    receipts: 'receipts',
    'Export Group': 'Export Group',
    'Export group': 'Export group',
    'Export file': 'Export file',
    'Export Selected': 'Export Selected',
    'Export selected': 'Export selected',
    'Export All': 'Export All',
    'Export all': 'Export all',

    // Category
    expense: 'Expense',
    income: 'Income',
    'bank statement': 'Bank Statement',
    document: 'Document',
    'no category': 'No category',

    // Search
    Showing: 'Showing',
    '1-result': 'result',
    'n-results': 'results',

    // Export dialog
    'Export Options': 'Export Options',
    'Choose how you want to receive the file':
      'Choose how you want to receive the file',
    'Download Zip': 'Download Zip',
    'Send by Email': 'Send by Email',
  },
};
